import { SeoPageModel } from '@app/core/services/seo/seo.model';

export const ErrorsSeo404Params = {
  title: 'Страница не найдена',
  description: 'Сервис по поиску музыкантов No1 в России и на Луне',
  image: '',
  url: '',
} as SeoPageModel;

export const ErrorsSeoPermissionParams = {
  title: 'Ошибка доступа',
  description: 'Сервис по поиску музыкантов No1 в России и на Луне',
  image: '',
  url: '',
} as SeoPageModel;

export const ErrorsSeoDeletedParams = {
  title: 'Страница удалена',
  description: 'Сервис по поиску музыкантов No1 в России и на Луне',
  image: '',
  url: '',
} as SeoPageModel;
